import React from 'react'
import { RefreshControl, Platform } from 'react-native'
import { useTheme } from '@ui-kitten/components'
import { useIsDarkMode } from '@src/config/theme'

const NewRefreshControl = (props: any) => {
  const theme = useTheme()

  const isDarkMode = useIsDarkMode()

  const tintColor = isDarkMode ? theme['theme.text.secondary'] : theme['theme.text.tertiary']

  return <RefreshControl tintColor={tintColor} {...props} />
}

export const RefreshControlComponent = Platform.OS === 'ios' ? NewRefreshControl : RefreshControl
